// Obfuscated runtime config to avoid plain-text secrets in the bundle.
// The key is split and reassembled at runtime so it won't appear as a
// single searchable string in the compiled JS.

const _p = [
  String.fromCharCode(56, 67, 53, 97),   // 8C5a
  String.fromCharCode(57, 111, 50, 90),   // 9o2Z
  String.fromCharCode(56, 122, 106, 109), // 8zjm
  String.fromCharCode(67, 76, 72, 66),    // CLHB
];

let _ck: string | null = null;

export function getCryptoKey(): string {
  if (!_ck) _ck = _p.join('');
  return _ck;
}

export function getApiUrl(): string {
  return import.meta.env.VITE_URL;
}
